import Slide1 from "../penpalSlides/Slide1.jpg";
import Slide2 from "../penpalSlides/Slide2.jpg";
import Slide3 from "../penpalSlides/Slide3.jpg";
import Slide4 from "../penpalSlides/Slide4.jpg";
import Slide5 from "../penpalSlides/Slide5.jpg";
import Slide6 from "../penpalSlides/Slide6.jpg";
import Slide7 from "../penpalSlides/Slide7.jpg";
import Slide8 from "../penpalSlides/Slide8.jpg";
import Slide9 from "../penpalSlides/Slide9.jpg";
import Slide10 from "../penpalSlides/Slide10.jpg";
import Slide11 from "../penpalSlides/Slide11.jpg";
import Slide12 from "../penpalSlides/Slide12.jpg";
import Slide13 from "../penpalSlides/Slide13.jpg";
import Slide14 from "../penpalSlides/Slide14.jpg";
import Slide15 from "../penpalSlides/Slide15.jpg";
import Slide16 from "../penpalSlides/Slide16.jpg";
import Slide17 from "../penpalSlides/Slide17.jpg";
import Slide18 from "../penpalSlides/Slide18.jpg";
import Slide19 from "../penpalSlides/Slide19.jpg";
import Slide20 from "../penpalSlides/Slide20.jpg";
import Slide21 from "../penpalSlides/Slide21.jpg";
import Slide22 from "../penpalSlides/Slide22.jpg";
import download from "../images/icons/download.png";

const NewPenpal = () => {
  const slides = [Slide1, Slide2, Slide3, Slide4, Slide5, Slide6, Slide7, Slide8, Slide9, Slide10, Slide11,
                 Slide12, Slide13,Slide14, Slide15, Slide16, Slide17, Slide18, Slide19, Slide20, Slide21, Slide22]

  const downloadUrl = "https://acrobat.adobe.com/id/urn:aaid:sc:VA6C2:319117dc-ffd3-4712-8235-77e4247c82b7";

  return (
    <div className = "w-full bg-gray-800">
      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
          padding: "1rem 1rem",
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <a
          href={downloadUrl}
          download
          style={{
            display: "flex",
            alignItems: "center",
            gap: "0.5rem",
            padding: "0.5rem 1rem",
            color: "#FFA500",
            borderRadius: "9999px",
            border: "1px solid #FFA500",
            textDecoration: "none",
            fontWeight: "",
            fontSize: "0.875rem",
          }}
        >
          <img
            src={download}
            alt="Download"
            style={{ width: "18px", height: "18px" }}
          />
          Download Presentation
        </a>
      </div>
        <div style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 1rem"}}>
            {slides.map((src, index) => (
                <div
                key={index}
                style={{
                    marginBottom: "1.5rem",
                    overflow: "hidden",
                    background: "#fff",
                    borderRadius: "12px",
                    boxShadow: "0 6px 15px rgba(0,0,0,0.1)",
                }}
                >
                <img
                    src={src}
                    alt={`Slide ${index + 1}`}
                    style={{
                    width: "100%",   
                    display: "block",   
                    }}
                />
                </div>
            ))}
        </div>
    </div>
  );
};

export default NewPenpal;
